// extracted by mini-css-extract-plugin
export default {"container":"PostDraftBarPublishButton-module__container--jZ2ic"};